import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useTeamCache } from '../team/cache'
import { useUserCache } from './cache'
import { useProfile } from './get'
import { isDefined, toResponseError, type UserAddInput, type UserAddSuccess } from '@terros/common'

export function useAddUser(): AddHookResponse<UserAddInput, UserAddSuccess> {
  const { company } = useProfile()
  const cache = useUserCache()
  const teamCache = useTeamCache()
  const mutation = useTantalimMutation<UserAddInput, UserAddSuccess>({ url: '/user/add' })

  async function add(input: UserAddInput): Promise<UserAddSuccess> {
    const isForAnotherCompany = isDefined(company) && company.companyId !== input.user.companyId
    const companyId = isForAnotherCompany ? company.companyId : undefined
    try {
      const output = await mutation.mutateAsync(input)
      cache.addUser(output.user, companyId)
      if (input.teamId) {
        teamCache.addTeamMember(input.teamId, output.user)
      }
      return output
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
